import AddressProofError from './AddressProof/AddressProofError';
class AddressProofFileSizeIsExceeded extends AddressProofError {
    constructor(options) {
        super('Address proof file size exceeds 15mb', options);
    }
}
export default AddressProofFileSizeIsExceeded;
